$(function () {
    $("#is_delivery_to_invoice").on("click", function () {
        if (this.checked) {
            $(".invoice").removeClass('d-none').addClass('d-none');
        } else {
            $(".invoice").removeClass('d-none');
        }
    });

    $("#delivery_edit").on("click", function () {
        $(".delivery").toggleClass('d-none');
        $(".invoice").addClass('d-none');
    });

    $("#invoice_edit").on("click", function () {
        $(".invoice").toggleClass('d-none');
        $(".delivery").addClass('d-none');
    });

    $("#new-address").on("click", function () {
        $(".new-address").toggleClass('d-none');
    });

    $('[name="is_delivery_to_invoice"]').on('change', function () {
        if (this.checked) {
            $('[name^="invoice"]').prop('required', false);
        } else {
            $('[name^="invoice"]').prop('required', true);
        }
    });
});
